<template>
  <div class="main">
    <div class="panel1">
      <div class="user" v-if="is_login">
        <span>您好，</span><span>{{ user_info.user_name }}</span
        ><a :href="logout_url">退出</a>
      </div>
      <div class="user" v-else></div>
      <h2 class="title-1">什么是刀塔故事会？</h2>
      <p>
        十年前的夏天，第一届DOTA2国际邀请赛在德国科隆举办，全世界的DOTA爱好者齐聚一堂。<br />从最初的一张WAR3地图到现在DOTA2，这十多年间诞生了许多有趣的梗，从“几把羊”到“梯哀冠军”，这些梗也见证了DOTA的一路发展，<br />欢迎各位玩家贡献出属于你的那份回忆，发生在远古遗迹之间的故事，你们这里肯定特别多。
      </p>
    </div>
    <div class="panel2" id="ranking">
      <h2 class="title-2">排行榜</h2>
      <p>
        8月20日12:00-9月18日12:00期间，每成功创建1条DOTA2词条将获得30积分，被点赞1次将获得1积分，最终将根据积分排行榜来发放奖品。
      </p>
      <div class="ranking-box">
        <div class="ranking-list">
          <div class="row">
            <ul class="col">
              <li>
                <span>名次</span>
                <span>作者</span>
                <span>最热词条</span>
                <span>贡献值</span>
              </li>
              <li v-for="list in rankItem.slice(0, 4)" :key="list.sort">
                <span v-if="[1, 2, 3].indexOf(list.sort) > -1">
                  <i :class="['champion' + list.sort]"></i>
                </span>
                <span v-else> {{ list.sort }}</span>
                <span :title="list.user_name">{{ list.user_name }}</span>
                <span :title="list.hot_item_title">{{
                  list.hot_item_title
                }}</span>
                <span>{{ list.points }}</span>
              </li>
            </ul>
            <ul class="col">
              <li>
                <span>名次</span>
                <span>作者</span>
                <span>最热词条</span>
                <span>贡献值</span>
              </li>
              <li v-for="list in rankItem.slice(4, 8)" :key="list.sort">
                <span>{{ list.sort }}</span>
                <span :title="list.user_name">{{ list.user_name }}</span>
                <span :title="list.hot_item_title">{{
                  list.hot_item_title
                }}</span>
                <span>{{ list.points }}</span>
              </li>
            </ul>
          </div>
          <div class="page-number">
            <span
              @click="switchRank(index)"
              :class="{ active: index == itemIndex }"
              v-for="(v, index) in totalPage"
              :key="v.user_id"
              >{{ index * 8 + 1 }} - {{ v * 8 }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="panel3" id="prize">
      <h2 class="title-3">奖品展示</h2>
      <img
        src="https://img.dota2.com.cn/file/a1/49/a149d715af4b5b75c623260f149a08bc1597738951.png"
        alt=""
      />
    </div>
    <div class="panel4" id="catStory">
      <div class="row">
        <div class="tabs">
          <p class="labels">
            <span
              @click="handleStoryType(1)"
              :class="{ active: storyType == 1 }"
              >推荐</span
            >
            <span
              @click="handleStoryType(2)"
              :class="{ active: storyType == 2 }"
              >热门</span
            >
            <span
              @click="handleStoryType(3)"
              :class="{ active: storyType == 3 }"
              >最新</span
            >
          </p>
          <div class="input-search" v-if="storyType != 1">
            <input
              class="search"
              type="text"
              name="entry"
              placeholder="搜索词条"
              @input="handleSearchChange"
              v-model="key_search"
            />
            <a
              href=""
              @click.prevent="handleSearchBtn"
              @keyup.enter="handleAddBook"
            ></a>
          </div>
          <a
            v-else
            @click.prevent="handleChangeBatch"
            href=""
            class="change-batch"
            >换一批</a
          >
        </div>
        <div class="classify" v-if="storyType != 1 && hide_tab">
          <button
            @click="handleTag('')"
            :class="{ active: tag_list_tag == '' }"
          >
            全部
          </button>
          <button
            :class="{ active: tag_list_tag == item }"
            @click="handleTag(item)"
            v-for="item in tag_list"
            :key="item"
          >
            {{ item }}
          </button>
        </div>
        <div class="classify" v-else></div>
        <div class="grids">
          <waterfall
            :col="col"
            :width="282"
            :gutterWidth="24"
            :data="storyData"
            :loadDistance="80"
            @loadmore="loadmore"
          >
            <div
              @click="catInfo(item.id)"
              class="cell-item"
              v-for="(item, index) in storyData"
              :key="index"
            >
              <div class="cell-item-header">
                <h3 :title="item.title">
                  {{ item.title }}
                </h3>
                <p>{{ item.author }}</p>
              </div>
              <div class="cell-item-body">
                <p class="text-content">
                  {{ item.content }}
                </p>
                <div class="img-box">
                  <img :src="item.image_url" alt="" />
                </div>
              </div>
              <div class="cell-item-footer">
                <div class="col" @click.stop="handleFabulous(item.id)">
                  <i :class="{ active: item.my_vote == 1 }"></i
                  ><span :class="{ active: item.my_vote == 1 }"
                    >赞<span>{{ item.upvote_count }}</span></span
                  >
                </div>
                <div class="col">
                  <i></i><span>分享</span>
                  <div class="tip">
                    <p class="code">
                      <vue-qr
                        class="icon"
                        :size="156"
                        :margin="0"
                        :data-text="
                          'https://act.dota2.com.cn/memes2020/share?id=' +
                            item.id
                        "
                        :text="
                          'https://act.dota2.com.cn/memes2020/share?id=' +
                            item.id
                        "
                        :logo-scale="100"
                        :logo-margin="2"
                      ></vue-qr>
                    </p>
                    <span>扫码分享该词条</span>
                  </div>
                </div>
              </div>
            </div>
          </waterfall>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogTableVisible" :show-close="false">
      <div class="story-info">
        <button class="x" @click="handleClose"></button>
        <div class="story-container">
          <button
            class="prev"
            :class="{ disabled: storyInfoIndex == 0 }"
            @click="handleCatChangeInfo('prev')"
          ></button>
          <button
            class="next"
            :class="{ disabled: storyInfoIndex == storyData.length - 1 }"
            @click="handleCatChangeInfo('next')"
          ></button>
          <div class="story-header" v-if="catStoryInfo.title">
            <h3>{{ catStoryInfo.title }}</h3>
            <div class="row">
              <div class="col">
                <span
                  >由 <span>{{ catStoryInfo.author }}</span> 创建的词条</span
                >
                <i v-for="item in catStoryInfo.tags" :key="item">{{ item }}</i>
              </div>
              <div class="col">
                <span @click="handleFabulous(catStoryInfo.id)"
                  ><i :class="{ active: catStoryInfo.my_vote == 1 }"></i
                  ><span :class="{ active: catStoryInfo.my_vote == 1 }"
                    ><strong>赞</strong> {{ catStoryInfo.upvote_count }}</span
                  ></span
                >
                <span @click="handleFabulous(catStoryInfo.id, 2)"
                  ><i :class="{ active: catStoryInfo.my_vote == 2 }"></i
                  ><span :class="{ active: catStoryInfo.my_vote == 2 }"
                    ><strong>踩</strong> {{ catStoryInfo.downvote_count }}</span
                  ></span
                >
                <div>
                  <i></i><span>分享</span>
                  <div class="tip">
                    <p class="code">
                      <vue-qr
                        class="icon"
                        :size="156"
                        :margin="0"
                        :data-text="
                          'https://act.dota2.com.cn/memes2020/share?id=' +
                            catStoryInfo.id
                        "
                        :text="
                          'https://act.dota2.com.cn/memes2020/share?id=' +
                            catStoryInfo.id
                        "
                        :logo-scale="100"
                        :logo-margin="2"
                      ></vue-qr>
                    </p>
                    <span>扫码分享该词条</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="story-body">
            <el-scrollbar>
              <p>
                {{ catStoryInfo.content }}
              </p>
              <div class="img-box">
                <img :src="catStoryInfo.image_url" alt="" />
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from '@/utils/http'
import { MEMES2020 } from '../api/index'
import { Dialog, Scrollbar } from 'element-ui'
import VueQr from 'vue-qr'
import waterfall from 'vue-waterfall2'
import Vue from 'vue'
Vue.use(waterfall)

import { mapMutations } from 'vuex'
import { DIALOG_OPTION } from '../store/mutation-types'
export default {
  data() {
    return {
      itemIndex: 0, //排行榜当前区间
      pageSize: 8, //排行榜每页个数
      rankItem: [], //排行榜每页数据
      dialogTableVisible: false, //弹框
      col: 4, //故事会列数
      storyPage: 1, //故事会第几页
      keyword: '', //搜索关键词
      storyData: [], //故事会数据
      storyType: 1, //故事会类型是推荐、热门、最新
      catStoryInfo: {}, //故事会列表详情
      storyInfoIndex: 0, //查看当前列表信息的位置
      tag_list: [], //标签列表
      tag_list_tag: '', //每个类型中的子标签
      storyEnd: false, //数据是否是最后一页
      httpCache: true, //禁止多次发送请求
      key_search: '', //搜索关键词
      hide_tab: true,
    }
  },
  components: {
    elDialog: Dialog,
    VueQr,
    elScrollbar: Scrollbar,
  },
  computed: {
    is_login() {
      return this.$store.state.base_info.is_logined
    },
    logout_url() {
      return this.$store.state.base_info.logout_url
    },
    user_info() {
      return this.$store.state.user_info
    },
    rank_list() {
      let rank_list = this.$store.state.base_info.rank_list || []
      for (let j = 0; j < rank_list.length; j++) {
        rank_list[j].sort = j + 1
      }
      return rank_list
    },
    totalPage() {
      return Math.ceil(this.rank_list.length / this.pageSize)
    },
  },
  watch: {
    rank_list() {
      this.rankItem = this.rank_list.slice(0, this.pageSize)
    },
  },
  created() {
    this.keyupEnter()
  },
  mounted() {
    //初始化排行榜
    this.rankItem = this.rank_list.slice(0, this.pageSize)

    //获取故事会信息
    this.getStoryData()
  },
  methods: {
    ...mapMutations([DIALOG_OPTION]),
    getStoryData() {
      http
        .post(MEMES2020, {
          task: 'item_list',
          type: this.storyType, //1默认,2热门,3最新三种
          page: this.storyPage, //页数，默认（type=1）下始终传1
          tag: this.tag_list_tag, //标签，从返回的tag_list中选择，默认传空（全部）
          keyword: this.keyword, //搜索关键词
        })
        .then(data => {
          if (data.status == 'success') {
            let { item_list, tag_list, page } = data.result
            this.tag_list = tag_list
            if (!this.$store.state.tag_list.length) {
              this.$store.state.tag_list = tag_list
            }

            if (page == 1) {
              this.storyData = item_list
            } else {
              this.storyData.push(...item_list)
            }
            this.storyPage += 1
            if (!item_list.length) this.storyEnd = true

            this.httpCache = true
          }
        })
    },
    switchRank(index) {
      //切换排行榜
      this.itemIndex = index
      this.rankItem = this.rank_list.slice(
        index * this.pageSize,
        index * this.pageSize + this.pageSize
      )
    },
    handleStoryType(type) {
      //切换故事会类型
      this.storyEnd = false
      this.storyType = type
      this.storyPage = 1
      this.tag_list_tag = ''
      this.keyword = ''
      this.key_search = ''
      this.hide_tab = true
      this.getStoryData()
    },
    handleChangeBatch() {
      //推荐换一批
      this.storyType = 1
      this.storyPage = 1
      this.tag_list_tag = ''
      this.keyword = ''
      this.getStoryData()
    },
    handleTag(tag) {
      //切换子标签
      this.storyEnd = false
      this.storyPage = 1
      this.keyword = ''
      this.tag_list_tag = tag
      this.getStoryData()
    },
    handleSearchBtn() {
      // 搜索关键词
      if (!this.key_search) return false
      this.storyEnd = false
      this.storyPage = 1
      this.tag_list_tag = ''
      this.keyword = this.key_search
      this.hide_tab = false
      this.getStoryData()
    },
    handleSearchChange() {
      //监听搜索内容
      if (!this.key_search) {
        this.handleStoryType(this.storyType)
      }
    },
    keyupEnter() {
      document.onkeydown = e => {
        if (e.keyCode === 13 && this.key_search) {
          this.handleSearchBtn()
        }
      }
    },
    handleAddBook() {
      if (this.validate()) {
        this._printQrcode()
      }
    },
    handleFabulous(id, type = 1) {
      //用户点赞
      if (this.is_login) {
        this.checkFabulous(id, type)
      } else {
        this.handleLogin()
      }
    },
    checkFabulous(id, up_down) {
      //点赞或者点踩
      http
        .post(MEMES2020, {
          task: 'vote_item',
          id,
          up_down,
        })
        .then(data => {
          if (data.status == 'success') {
            let { upvote, downvote, status } = data.result
            //故事会列表点赞
            this.storyData.forEach(item => {
              if (item.id == id) {
                item.upvote_count = upvote
                item.downvote_count = downvote
                item.my_vote = status
                this.catStoryInfo = Object.assign({}, item)
              }
            })
          } else {
            this.$store.commit(DIALOG_OPTION, {
              dialogTableVisible: true,
              type: 'MESSAGE',
              data: {
                content: data.error,
              },
            })
          }
        })
    },
    catInfo(id) {
      //查看词条详情
      this.storyData.forEach((item, index) => {
        if (id === item.id) {
          this.catStoryInfo = {}
          setTimeout(() => {
            this.catStoryInfo = Object.assign({}, item)
          }, 10)
          this.storyInfoIndex = index
          this.dialogTableVisible = true
        }
      })
    },
    handleCatChangeInfo(type) {
      //查看上一条或下一条
      if (type === 'next') {
        if (this.storyInfoIndex <= this.storyData.length - 1) {
          this.storyInfoIndex += 1
        } else {
          this.storyInfoIndex = this.storyData.length
        }
      } else {
        if (this.storyInfoIndex > 0) {
          this.storyInfoIndex -= 1
        } else {
          this.storyInfoIndex = 0
        }
      }
      this.catStoryInfo = {}
      setTimeout(() => {
        this.catStoryInfo = Object.assign(
          {},
          this.storyData[this.storyInfoIndex]
        )
      }, 0)
    },
    loadmore() {
      //页面滚动到底部加载词条
      if (!this.storyEnd && this.httpCache) {
        this.getStoryData()
        this.httpCache = false
      }
    },
    handleLogin() {
      this.$store.commit(DIALOG_OPTION, {
        dialogTableVisible: true,
        type: 'EVENTS_LOGIN',
        data: {},
      })
    },
    handleClose() {
      this.dialogTableVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.x {
  position: absolute;
  right: -6px;
  top: 62px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  background-image: url('../assets/close.png');
}
h2 {
  height: 92px;
  font-size: 0;
  background-repeat: no-repeat;
  background-position: center center;
}
.main {
  background: #071315
    url(https://img.dota2.com.cn/file/d5/0a/d50affafac1cf9e186db92cae513a7541595995571.jpg)
    no-repeat center top;
  font-size: 16px;
  color: #9a9a9a;
  text-align: center;
  min-height: 3052px;
}
.panel1 {
  .title-1 {
    margin-top: -22px;
    background-image: url('../assets/title-1.png');
  }
  .user {
    position: relative;
    top: -46px;
    height: 25px;
    color: #9a9a9a;
    a {
      margin-left: 10px;
      color: #79e4f7;
      text-decoration: underline;
    }
  }
  p {
    line-height: 30px;
    margin-top: 48px;
  }
}
.panel2 {
  padding-top: 46px;
  .title-2 {
    margin-bottom: 40px;
    background-image: url('../assets/title-2.png');
  }
  .ranking-box {
    width: 1230px;
    height: 382px;
    margin: 40px auto 0;
    padding: 15px;
    border-radius: 18px;
    border: solid 1px #f07f0d;
  }
  .ranking-list {
    background-color: #232529;
    border-radius: 10px;
    height: 100%;
    padding: 10px;
    font-size: 14px;
    .row {
      height: 263px;
      .col {
        float: left;
        width: 583px;
        height: 100%;
        background-image: url('../assets/line.png');
        background-position-y: 101px;
        background-repeat: no-repeat;
        &:last-child {
          float: right;
        }
        li {
          text-align: left;
          height: 52px;
          margin-top: 2px;
          &:nth-child(1) {
            margin-top: 0;
            height: 48px;
            border-radius: 8px;
            background-color: #34373d;
            span {
              height: 48px;
              line-height: 48px;
              font-weight: bold;
              &:first-child,
              &:last-child {
                color: #9a9a9a;
              }
            }
          }
          span {
            float: left;
            height: 52px;
            line-height: 52px;
            i {
              width: 28px;
              height: 26px;
              display: inline-block;

              vertical-align: middle;
              position: relative;
              top: -3px;
              &.champion1 {
                background-image: url('../assets/icons.png');
              }
              &.champion2 {
                background-image: url('../assets/icons.png');
                background-position-y: -54px;
              }
              &.champion3 {
                background-image: url('../assets/icons.png');
                background-position-y: 100%;
              }
            }
            &:nth-child(1) {
              width: 78px;
              text-align: center;
              color: #fff;
              font-weight: bold;
            }
            &:nth-child(2) {
              width: 168px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding-right: 10px;
            }
            &:nth-child(3) {
              width: 190px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            &:nth-child(4) {
              width: 147px;
              text-align: center;
              color: #79e4f7;
            }
          }
        }
      }
    }
    .page-number {
      color: #5a5a5a;
      margin-top: 25px;
      span {
        font-size: 14px;
        padding: 8px 20px;
        border-bottom: 2px solid #33383c;
        cursor: pointer;
        transition: all 0.2s;
        &.active,
        &:hover {
          border-color: #fa9a28;
          color: #fa9a28;
        }
      }
    }
  }
}
.panel3 {
  margin-top: 84px;
  .title-3 {
    margin-bottom: 50px;
    background-image: url('../assets/title-3.png');
  }
  p {
    line-height: 30px;
    margin: 40px 0 52px;
  }
}
.panel4 {
  padding: 47px 0;
  .row {
    width: 1200px;
    margin: 0 auto;
  }
  .tabs {
    height: 53px;
    border-bottom: 1px solid #36373a;
    padding-left: 5px;
    .labels {
      float: left;
      font-size: 20px;
      letter-spacing: 1px;
      color: #cfcfcf;
      padding-top: 10px;
      span {
        position: relative;
        cursor: pointer;
        margin-left: 40px;
        transition: all 0.2s;
        &:first-child {
          margin-left: 0;
        }
        &.active,
        &:hover {
          color: #fa9a28;
          &::before {
            content: '';
            position: absolute;
            left: -5px;
            bottom: -17px;
            width: 50px;
            height: 0;
            border-top: 2px solid #fa9a28;
          }
        }
      }
    }
    .input-search {
      position: relative;
      width: 296px;
      float: right;
      input {
        width: 100%;
        height: 42px;
        background-color: #232529;
        border-radius: 5px;
        border: none;
        padding: 0 42px 0 20px;
        color: #fff;
        font-size: 16px;
        font-family: 'Microsoft YaHei';
      }
      a {
        position: absolute;
        top: 10px;
        right: 10px;
        width: 22px;
        height: 22px;
        background-image: url('../assets/icon-search.png');
      }
    }
    .change-batch {
      float: right;
      color: #fa9a28;
      font-size: 16px;
      display: flex;
      align-items: center;
      padding-top: 10px;
      &::before {
        content: '';
        width: 17px;
        height: 15px;
        margin-right: 8px;
        background-image: url(https://img.dota2.com.cn/file/fe/99/fe99c46cc0b894ccfb418561b5a1231a1596436380.png);
      }
    }
  }
  .classify {
    text-align: left;
    margin-top: 20px;
    button {
      cursor: pointer;
      letter-spacing: 1px;
      color: #cfcfcf;
      font-size: 14px;
      padding: 12px 25px;
      background-color: #1d1f23;
      border-radius: 5px;
      margin-left: 10px;
      transition: all 0.2s;
      &:first-child {
        margin-left: 0;
      }
      &.active,
      &:hover {
        background-color: #fa9a28;
        color: #fff;
      }
    }
  }
  .grids {
    padding-top: 20px;
    .cell-item {
      margin-bottom: 24px;
      padding: 20px;
      background: #153a48
        url('https://img.dota2.com.cn/file/e8/ae/e8aea53b758d5ec42eee91ae49f6af291596620348.jpg')
        no-repeat center bottom;
      border: 1px solid transparent;
      transition: all 0.2s;
      box-shadow: 0px 2px 8px 0px rgba(26, 25, 25, 0.17);
      border-radius: 5px;
      cursor: pointer;
      &:hover {
        border-color: #278d94;
      }
    }
    .cell-item-header {
      position: relative;
      height: 48px;
      font-size: 14px;
      color: #fff;
      padding-left: 10px;
      text-align: left;
      h3 {
        font-size: 20px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      p {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 48px;
        width: 3px;
        background-color: #a1f5ff;
      }
    }
    .cell-item-body {
      margin: 13px 0;
      text-align: left;
      font-size: 14px;
      // min-height: 120px;
      color: #c7d1da;
      .text-content {
        line-height: 170%;
        margin-bottom: 15px;
        overflow: hidden;
      }
      .img-box {
        overflow: hidden;
        &:hover {
          img {
            transform: translate3d(0, 0, 0) scale(1.2);
          }
        }
        img {
          display: block;
          transition: transform 1.2s;
          max-width: 100%;
        }
      }
    }
    .cell-item-footer {
      height: 17px;
      font-size: 14px;
      color: #cfcfcf;
      span,
      i {
        display: inline-block;
        vertical-align: middle;
        line-height: 100%;
      }
      .col {
        &:first-child {
          float: left;
          span {
            &.active {
              color: #fa9a28;
            }
            span {
              padding-left: 6px;
            }
          }
          i {
            width: 17px;
            height: 16px;
            margin-top: -2px;
            cursor: pointer;
            background-image: url('../assets/icon-fabulous.png');
            margin-right: 6px;
            &.active {
              background-position-y: -19px;
            }
          }
        }
        &:last-child {
          cursor: pointer;
          float: right;
          position: relative;
          i {
            width: 18px;
            height: 17px;
            margin-right: 5px;
            background-image: url('../assets/icon-share.png');
          }
          &:hover {
            .tip {
              opacity: 1;
            }
          }
          .tip {
            opacity: 0;
            pointer-events: none;
            position: absolute;
            left: -152px;
            top: -212px;
            z-index: 99;
            background-color: #fff;
            width: 180px;
            height: 210px;
            color: #5a5a5a;
            .code {
              width: 156px;
              height: 156px;
              margin: 15px auto 10px;
              background-color: #33383c;
            }
          }
        }
      }
    }
    /deep/ .vue-waterfall {
      .vue-waterfall-column {
        .cell-item:first-child {
          .cell-item-body {
            min-height: 120px;
          }
        }
      }
    }
  }
}
.story-info {
  position: relative;
  width: 986px;
  margin: 0 auto;
  height: 776px;
  padding-top: 64px;
  font-size: 14px;
  background-image: url(https://img.dota2.com.cn/file/5f/00/5f0095a98ce0b4738372608125ee8b841596100336.png);
  .prev,
  .next {
    position: absolute;
    top: 50%;
    margin-top: -30px;
    width: 60px;
    height: 60px;
    background-image: url('../assets/swiper-btn-next.png');
    background-position: right top;
    cursor: pointer;
    &:hover {
      background-position-x: -90px;
    }
    &.disabled {
      pointer-events: none;
      background-position-x: 0;
    }
  }
  .prev {
    left: -30px;
  }
  .next {
    right: -30px;
    transform: rotate(180deg);
  }
  .story-container {
    width: 860px;
    margin: 0 auto;
    padding: 0 10px 0 40px;
  }
  .story-header {
    padding-top: 40px;
    padding-right: 30px;
    h3 {
      font-size: 36px;
      color: #fff;
      line-height: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: left;
    }
    .row {
      padding-top: 20px;
      .col {
        &:first-child {
          float: left;
          color: #cfcfcf;
          padding-top: 4px;
          > span {
            margin-right: 15px;
            span {
              vertical-align: top;
              display: inline-block;
              max-width: 200px;
              color: #fa9a28;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
          i {
            font-style: normal;
            background-color: #042b33;
            padding: 5px 12px;
            line-height: 100%;
            border-radius: 29px;
            margin: 0 5px;
            font-size: 14px;
            color: #4f99a5;
          }
        }
        &:last-child {
          float: right;
          color: #b5f0fa;
          > div {
            position: relative;
            cursor: pointer;
            i,
            span {
              display: inline-block;
              vertical-align: middle;
            }
            display: inline-block;
            vertical-align: middle;
            margin-left: 14px;
            i {
              width: 18px;
              height: 17px;
              margin-right: 6px;
              background-image: url('../assets/icon-share2.png');
            }
            &:hover {
              .tip {
                opacity: 1;
              }
            }
            .tip {
              opacity: 0;
              pointer-events: none;
              position: absolute;
              left: -110px;
              top: 36px;
              z-index: 99;
              background-color: #fff;
              width: 180px;
              height: 210px;
              color: #5a5a5a;
              .code {
                width: 156px;
                height: 156px;
                margin: 15px auto 10px;
                background-color: #33383c;
              }
            }
          }
          > span {
            cursor: pointer;
            display: inline-block;
            vertical-align: middle;
            i,
            span {
              display: inline-block;
              vertical-align: middle;
            }
            &:nth-child(1) {
              strong {
                font-weight: normal;
              }
              span {
                color: #b5f0fa;
                &.active {
                  color: #fa9a28;
                }
              }
              i {
                width: 17px;
                height: 16px;
                background-position-y: -18px;
                margin-right: 6px;
                background-image: url('../assets/icon-fabulous2.png');
                &.active {
                  background-position-y: 0;
                }
              }
            }
            &:nth-child(2) {
              margin-left: 14px;
              strong {
                font-weight: normal;
              }
              span {
                color: #b5f0fa;
                &.active {
                  color: #fa5928;
                }
              }
              i {
                position: relative;
                top: 2px;
                width: 17px;
                height: 16px;
                margin-right: 6px;
                background-image: url('../assets/icon-cai.png');
                background-position-x: 0;
                &.active {
                  background-position-y: -16px;
                }
              }
            }
          }
        }
      }
    }
  }
  .story-body {
    padding-top: 22px;
    clear: both;
    color: #c7d1da;
    height: 490px;
    p {
      line-height: 180%;
      text-align: left;
      padding-right: 26px;
    }
    .img-box {
      margin-top: 20px;
      padding-right: 30px;
      img {
        max-width: 100%;
        vertical-align: bottom;
      }
    }
  }
}

/deep/.el-dialog {
  background-color: transparent;
  box-shadow: initial;
  width: 100%;
  height: 100%;
  display: table;
  margin: 0 !important;
}
/deep/.el-dialog__header {
  display: none;
}
/deep/.el-dialog__body {
  padding: 0;
  vertical-align: middle;
  display: table-cell;
}

/deep/ .el-scrollbar__wrap {
  height: 490px;
  overflow-x: hidden;
}
/deep/ .el-scrollbar__thumb {
  background-color: #b5f0fa;
  left: 0px;
}
/deep/ .el-scrollbar__bar {
  opacity: 1;
  width: 5px;
}
</style>
